import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';

const useSavedVideoPreview = (hostId = '') => {
  const manifest = useSelector(state => hostedVideoSelectors.selectManifestFor(state, hostId));

  const isCurrentVideoManifest = !!manifest;

  const videoSmallestPreview = useSelector(state => hostedVideoSelectors.selectSmallestPreview(state, hostId));

  const [videoPreview, setVideoPreview] = useState<typeof videoSmallestPreview>();

  useEffect(() => {
    isCurrentVideoManifest && !videoPreview && setVideoPreview(videoSmallestPreview);
  }, [hostId, videoSmallestPreview]);

  return videoPreview;
};

export default useSavedVideoPreview;
